import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Typography,
  Card,
  Fab,
  LinearProgress,
  Grid,
  TextField,
  Icon
} from '@material-ui/core';
import useDebounce from 'hooks/UseDebounce';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import ScrollTop from 'components/ToolbarMenu/ScrollOnTop';
import {
  getBrands,
  getStoreProductsApi,
  getFullfilmentBannerSlidesApi
} from 'api';
import { BackdropCircular, Breadcrumb } from 'components';
import PartnersSlider from '../affiliates/PartnersSlider';
import FulfillmentBrands from './fulfillmentBrands';


export default function DirectFulfillment() {
  const dispatch = useDispatch();
  const {directFulfillmentBrands, loading: loadingBrands} = useSelector((state) => state.brands);
  const {store_products, loading, error} = useSelector((state) => state.products);
  const {fullfilmentSlides, loadingFullfilmentSlides} = useSelector((state) => state.partners);
  const userStore = useSelector((state) => state.user?.profile?.stores?.[0]);
  const scrolledContainerRef = useRef(null);
  const [searchBrand, setSearchBrand] = useState('');

  useEffect(() => {
    if (!directFulfillmentBrands.length) {
      getBrands({dispatch, fullfilledByDermpro: '1'});
    }

    if (store_products.catalogProducts === undefined && userStore?.isCreated) {
      getStoreProductsApi({dispatch});
    }

    if (!fullfilmentSlides.length) {
      getFullfilmentBannerSlidesApi({dispatch});
    }
  }, []);

  const handleChange = useCallback((event) => {
    setSearchBrand((event.target.value).toLowerCase());
  }, []);

  const debouncedSearchBrand = useDebounce(searchBrand, 300);

  return (
    <div className="flex-grow min-h-full-screen scroll-y" ref={scrolledContainerRef}>
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Direct Fulfillment' }
          ]}
        />
      </div>
      <div className="mx-10">
        <PartnersSlider slides={fullfilmentSlides} type="direct-fulfillment" />
      </div>
      <Card className="px-16 pt-8 pb-20 m-10 mb-25">
        <Typography variant="h1" className="text-dark-gray text-32 font-semibold my-8">Direct Fulfillment</Typography>
        {!loading && error && <div>Something went wrong</div>}
        {loading && !error && <LinearProgress className="m-10" />}
        {!loading && !error &&
          <Grid container className="pb-12">
            <Grid item xs={12} className="flex justify-between items-center mb-12">
              <TextField
                label={
                  <div className="flex items-center">
                    <Icon className="text-20 mr-2">search</Icon>
                    <span>Search Brand</span>
                  </div>
                }
                fullWidth
                className="max-w-300"
                variant="outlined"
                onChange={handleChange}
                id="back-to-top-anchor"
              />
            </Grid>
            {!directFulfillmentBrands.length ?
              <div className="p-2 text-muted">No Direct Fulfillment Brands</div>
              :
              <FulfillmentBrands results={directFulfillmentBrands} debouncedSearchBrand={debouncedSearchBrand} />
            }

          </Grid>
        }
      </Card>
      <ScrollTop refEl={scrolledContainerRef.current}>
        <Fab
          color="secondary"
          className="MuiButtonBase-root MuiFab-root MuiFab-sizeSmall MuiFab-secondary custom-scroll-button"
          size="small"
          aria-label="scroll back to top"
        >
          <KeyboardArrowUpIcon />
        </Fab>
      </ScrollTop>
      <BackdropCircular loading={loadingBrands || loadingFullfilmentSlides} />
    </div>
  );
}
